export const CONNECTORS_DASHBOARD_PATH = "/connectors-dashboard";

export const CONNECTOR_PROVIDER_SLUGS = {
  apigeeEdge: "apigee-edge",
  apigeeOpdk: "apigee-opdk",
  apigeeHybrid: "apigee-hybrid",
  apigeeX: "apigee-x",
} as const;

export type ConnectorProviderSlug =
  (typeof CONNECTOR_PROVIDER_SLUGS)[keyof typeof CONNECTOR_PROVIDER_SLUGS];

export function connectorAddPath(providerSlug: ConnectorProviderSlug): string {
  return `${CONNECTORS_DASHBOARD_PATH}/${providerSlug}/add`;
}
